<template>
    <div
        @click.self="handleCancel($event)"
        class="fixed inset-0 z-50 flex justify-end items-center bg-gray-700"
        :class="transition ? 'bg-opacity-50' : 'bg-opacity-0'"
    >
    <form  @submit.prevent class="bg-white shadow-2xl h-full pb-24 transition-all duration-200 ease-out w-full sm:max-w-md overflow-auto overflow-y-scroll"
    :class="transition ? 'mt-0 opacity-100' : '-mr-20 opacity-0'">
        <div >
            <!--Form-->
            <div class="grid grid-cols-1 h-min gap-2 px-4 pt-4">
                <div class="pb-1">
                    <div class="flex justify-between items-center">
                        <!-- title -->
                        <h2 class="text-lg font-medium text-gray-900 pt-1">{{ title ? title : 'Success!'}}</h2>
                        <LucideIcon @click="handleCancel($event)" name="CircleX" :size="32" :stroke-width="2" color="#4b5563" class="cursor-pointer hover:bg-gray-200 bg-white rounded-full" />
                    </div>
                    <!-- subtitle -->
                    <p v-if="subtitle" class="text-sm text-gray-900">
                        {{subtitle}}
                    </p>
                </div>
                <slot></slot>
            </div>
        </div>
        <!--Footer-->
        <div class="flex justify-end items-center gap-2 bg-[#F5F2FB] fixed absolute bottom-0 right-0 w-full sm:max-w-md h-16 px-4"
            :class="transition ? 'mt-0 opacity-100' : '-mr-20 opacity-0'">
            <!-- <CustomButton id="confirm_modal_cancel" text="Cancel" type="navigate" @click="handleCancel($event)"/> -->
            <CustomButton :disabled="!valid" id="confirm_modal_confirm" :text=submitButtonText :loading="loading" type="action" @click="handleConfirm($event)"/>
        </div>
        </form>
    </div>
</template>

<script>
import CustomButton from '@/components/inputs/CustomButton.vue';
import LucideIcon from "@/components/LucideIcon.vue";

export default {
    name: "FormModal",
    components: {
        CustomButton,
        LucideIcon
    },
	props: {
		title: String,
		subtitle: String,
        valid:Boolean,
        loading:Boolean,
        submitButtonText: {
        type: String,
        default: "Submit"
        },
	},
    data() {
        return {
            transition: false
        }
    },
    methods: {
        handleConfirm(event) {
            // this.transition = false;
            // setTimeout(() => this.$emit('confirm', event), 200)
            this.$emit('confirm', event)
        },
        handleCancel(event) {
            // this.transition = false;
            // setTimeout(() => this.$emit('cancel', event), 200)
            this.$emit('cancel', event)
        }
    },
    mounted() {
        // this.$nextTick(function() {
        //     this.transition = true;
        // })
        this.transition = true
        
    }

}
</script>